import React, { Component } from 'react';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import './Table.css';

const TableSimple = props => {
    const rows = props.data.map(e => {
        return (
            <tr>
                <th>{e[0]}</th>
                <th>{e[1]}</th>
                <th>{e[2]}</th>
                {e[4] &&
                 <th><a href={e[4]}>{e[3]}</a></th>
                }
            </tr>
        )
    });
    return (
        <table style={{width: '100%'}}>
            {rows}
        </table>
    )
};

const MaterialTable = props => {
    const rows = props.data.map(e => {
        return (
            <TableRow>
                <TableCell padding="dense">{e[0]}</TableCell>
                <TableCell padding="dense">{e[1]}</TableCell>
                <TableCell padding="dense">{e[2]}</TableCell>
                {e[4] &&
                <TableCell padding="dense"><a href={e[4]}>{e[3]}</a></TableCell>
                }
                {!e[4] && <TableCell padding="dense">{e[3]}</TableCell>}
            </TableRow>
        )
    });
    if (!props.data[0]){
        return(<div></div>)
    }

    const fRow = props.data[0];

    return (
    <Table>
        <TableHead>
            <TableRow>
                <TableCell> {fRow[0]} </TableCell>
                <TableCell> {fRow[1]} </TableCell>
                <TableCell> {fRow[2]} </TableCell>
                <TableCell> {fRow[3]} </TableCell>
            </TableRow>
        </TableHead>

        <TableBody>
            {rows.slice(1)}
        </TableBody>

    </Table>
    )
};

export {TableSimple, MaterialTable};


// WEBPACK FOOTER //
// ./src/components/Table.js